export class Department {
  id: number;
  number: number;
  description: string;
  factoryId: number;
}
